import { render } from "./template-children-modal.vue?vue&type=template&id=073c4b24&scoped=true"
import script from "./template-children-modal.vue?vue&type=script&lang=js"
export * from "./template-children-modal.vue?vue&type=script&lang=js"

import "./template-children-modal.vue?vue&type=style&index=0&id=073c4b24&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073c4b24"]])

export default __exports__